import { useinsertdata, useinsertdatawithoutimage } from '../../Hooks/usePostData';
import {
  Get_Error,
  login,
  SignUp,
  Get_All_Users_log,
  Get_All_Users_log_forsearch,
  Get_One_USer,
  Update_One_USer_Main_Data,
  Change_Password_Type,
  team_leaders_type,
  Get_All_Users_log_forsearch_not_active,
  Logout_All_Users_And_Deactivate_Except_Admins,
  LogOutselecteduser_Type,
} from '../Types';
import usegetdata from '../../Hooks/useGetData';
import { UpdateDatawithimage, UpdateProductdata } from '../../Hooks/useUpdateData';

//SignUp action
export const SignUp_Actionn = (body) => async (dispatch) => {
  try {
    const res = await useinsertdata(`/api/v1/Signup`, body);

    dispatch({
      type: SignUp,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.res,
    });
  }
};



// before 13-7-2026
//SignUp action
// export const Login_Actionn = (body) => async (dispatch) => {
//   try {
//     // تأكد من أن body يحتوي على fcmToken
//     const res = await useinsertdatawithoutimage(`api/v1/Signup/login`, body);

//     dispatch({
//       type: login,
//       payload: res,
//     });
//   } catch (e) {
//     console.error('❌ Login Error:', e.response?.data?.message);

//     dispatch({
//       type: Get_Error,
//       payload: e.response?.data?.message || 'حدث خطأ ما',
//     });
//   }
// };






// after 13-7-2026
export const Login_Actionn = (body) => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`api/v1/Signup/login`, body);

    // ✅ جديد — احفظ الـ deviceId اللي الباك إند رجّعه في الـ response
    if (res?.data?.deviceId) {
      localStorage.setItem('deviceId', res.data.deviceId);
    }

    dispatch({
      type: login,
      payload: res,
    });
  } catch (e) {
    console.error('❌ Login Error:', e.response?.data?.message);

    dispatch({
      type: Get_Error,
      payload: e.response?.data?.message || 'حدث خطأ ما',
    });
  }
};

//get all users-log for sales
export const Getalldatauserlogsales = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Signup?role=sales`);

    dispatch({
      type: Get_All_Users_log,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};

//get all users-log for search active only
export const Getalldatauserlog_forsearch = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Signup?isactivefordelete=true`);

    dispatch({
      type: Get_All_Users_log_forsearch,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};

//get all users-log for search not active only

export const Getalldatauserlog_forsearch_not_active = () => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Signup?isactivefordelete=false`);

    dispatch({
      type: Get_All_Users_log_forsearch_not_active,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};

//get one users-log for search
export const Get_One_user_data = (id) => async (dispatch) => {
  try {
    const res = await usegetdata(`/api/v1/Signup/${id}`);

    dispatch({
      type: Get_One_USer,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};

//get one users-log for search
export const Update_One_user_Main_data_Action = (id, body) => async (dispatch) => {
  try {
    const res = await UpdateDatawithimage(`/api/v1/Signup/${id}`, body);

    dispatch({
      type: Update_One_USer_Main_Data,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};

// change Password
export const Change_Password_Action = (id, body) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`/api/v1/Signup/changeMyPassword/${id}`, body);

    dispatch({
      type: Change_Password_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e + 'error',
    });
  }
};

//force log out all users exept admins
export const Force_Logout_All_Users_Exept_Admins = () => async (dispatch) => {
  try {
    const res = await useinsertdatawithoutimage(`api/v1/Signup/logout-all`);

    dispatch({
      type: Logout_All_Users_And_Deactivate_Except_Admins,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.response, // تصحيح هنا من e.res إلى e.response
    });
  }
};

//force log out selected user
export const Force_Logout_selected_User = (userid) => async (dispatch) => {
  try {
    const res = await UpdateProductdata(`api/v1/Signup/logout/${userid}`);

    dispatch({
      type: LogOutselecteduser_Type,
      payload: res,
    });
  } catch (e) {
    dispatch({
      type: Get_Error,
      payload: e.response, // تصحيح هنا من e.res إلى e.response
    });
  }
};
